import React from 'react';

function GameEventSubstitution({ event, byHomeTeam }) {
  const { minuteWithStoppageTime, inPlayerName, outPlayerName } = event;

  if (!byHomeTeam) {
    return (
      <div className="match-timeline__row">
        <div className="match-timeline__team match-timeline__team--left match-timeline__team--empty" />
        <div className="match-timeline__time text-small fw-bold">
          {minuteWithStoppageTime}
        </div>
        <div className="match-timeline__team match-timeline__team--right">
          <div className="match-timeline__connector" />
          <div className="timeline-event timeline-event--comp-blue-3 gap-2">
            <span className="order-1">
              In: {inPlayerName} Ut: {outPlayerName}
            </span>
            <div className="d-flex flex-column order-0">
              <svg
                className="arrow--left arrow--red"
                width="11"
                height="13"
                viewBox="0 0 11 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                  fill="currentColor"
                />
              </svg>
              <svg
                className="arrow--right arrow--green"
                width="11"
                height="13"
                viewBox="0 0 11 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="match-timeline__row">
      <div className="match-timeline__team match-timeline__team--left">
        <div className="timeline-event timeline-event--comp-blue-3 gap-2">
          <span className="order-1 text-lg-end">
            In: {inPlayerName} Ut: {outPlayerName}
          </span>
          <div className="d-flex flex-column order-0 order-lg-1">
            <svg
              className="arrow--left arrow--red"
              width="11"
              height="13"
              viewBox="0 0 11 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                fill="currentColor"
              />
            </svg>
            <svg
              className="arrow--right arrow--green"
              width="11"
              height="13"
              viewBox="0 0 11 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
        <div className="match-timeline__connector" />
      </div>
      <div className="match-timeline__time text-small fw-bold">
        {minuteWithStoppageTime}
      </div>
      <div className="match-timeline__team match-timeline__team--right match-timeline__team--empty" />
    </div>
  );
}

export default GameEventSubstitution;
